export function lowercase<T extends string>(s: T): Lowercase<T> {
    return s.toLowerCase() as Lowercase<T>
}

export function uppercase<T extends string>(s: T): Uppercase<T> {
    return s.toUpperCase() as Uppercase<T>
}

export function capitalize<T extends string>(s: T): Capitalize<T> {
    return (s.charAt(0).toUpperCase() + s.slice(1)) as Capitalize<T>
}
